const ReturnStatus = Object.freeze({
  NORMAL: 'NORMAL',
  LANGUAGE_NOT_SUPPORTED: 'LANGUAGE_NOT_SUPPORTED',
  PREFETCH_DATA: 'PREFETCH_DATA',
  LOW_AUTHOR_COUNT: 'LOW_AUTHOR_COUNT',
  EMPTY_BECAUSE_LOW_COUNT: 'EMPTY_BECAUSE_LOW_COUNT',
  NO_COUNT: 'NO_COUNT',
  TRUNCATED: 'TRUNCATED'
})
export default ReturnStatus
export type ReturnStatusStrings = typeof ReturnStatus[keyof typeof ReturnStatus]
// RESERVE BELOW
